const gradients = [
  ['#00CC9E', '#06B3D8'],
  ['#157AFB', '#0AD1BD'],
  ['#BD46CC', '#FC4A7E'],
  ['#3023AE', '#C86DD7'],
  ['#157AFB', '#0750A8'],
  ['#77D447', '#159F5D'],
  ['#FBD760', '#FE8540'],
  ['#D52A45', '#E86A3D'],
  ['#B0D63C', '#79A620'],
  ['#7391C9', '#57B2E7'],
  ['#989AA7', '#466171'],
  ['#8483C6', '#3D44A6'],
]

export const getRandomGradient = () => {
  return gradients[Math.floor(Math.random() * gradients.length)]
}


// WEBPACK FOOTER //
// ./src/layouts/OnboardingCLPCustomizeStep/helpers/index.js